import { forwardRef } from 'react';

import LinkBase from 'next/link';

import { ButtonVariantProps, buttonVariants } from 'app/theme/button';
import { cn } from 'app/utils/styles.utils';
import { LinkProps as LinkPropsBase } from 'app/types/all';

export type LinkProps = LinkPropsBase & ButtonVariantProps;

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({className, children, href, variant = 'clean', size, ...props}, ref) => {
    return (
      <LinkBase
        ref={ref}
        className={cn(buttonVariants({variant, size}), className)}
        href={typeof href === 'string' ? href : href.href ?? href}
        {...props}>
        {children}
      </LinkBase>
    );
  },
);

Link.displayName = 'Link';
